import { render, staticRenderFns } from "./LocationPerformanceList.vue?vue&type=template&id=c4b8fe70&scoped=true&"
import script from "./LocationPerformanceList.vue?vue&type=script&lang=js&"
export * from "./LocationPerformanceList.vue?vue&type=script&lang=js&"
import style0 from "./LocationPerformanceList.vue?vue&type=style&index=0&id=c4b8fe70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b8fe70",
  null
  
)

/* custom blocks */
import block0 from "./LocationPerformanceList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4b8fe70')) {
      api.createRecord('c4b8fe70', component.options)
    } else {
      api.reload('c4b8fe70', component.options)
    }
    module.hot.accept("./LocationPerformanceList.vue?vue&type=template&id=c4b8fe70&scoped=true&", function () {
      api.rerender('c4b8fe70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/locations/LocationPerformanceList.vue"
export default component.exports